import React, { ReactNode, PropsWithChildren } from 'react';
import { TabPanel, useTabBarContext } from '../../../../Tabs';
import MultiStepFormActions from './MultiStepFormActions';

type StepProps = PropsWithChildren<{
  id: string;
  buttonLabel: string;
  renderSubmitAndLiveRegion?: ReactNode;
  disabled?: boolean;
}>;

export default function Step({ id, children, buttonLabel, renderSubmitAndLiveRegion, disabled }: StepProps) {
  const { getCurrentTabIndexById } = useTabBarContext();

  return (
    <TabPanel id={id} buttonLabel={`${getCurrentTabIndexById(id) + 1}. ${buttonLabel}`} disabled={disabled}>
      <div className="multi-step-form">
        <div className="multi-step-form__form-container">{children}</div>
        <MultiStepFormActions renderSubmitAndLiveRegion={renderSubmitAndLiveRegion} tabId={id} />
      </div>
    </TabPanel>
  );
}
